import React, { useState, useMemo } from 'react';
// import { X } from 'lucide-react';
import '../styles/TimelinePanel.css';
import GenericOverviewSideCard from '../../genericComponents/GenericOverviewSideCard';

/**
 * Format a date string/epoch to "MMM-YYYY" (e.g. "Feb-2025")
 */
const formatTimelineDate = (dateValue) => {
    if (!dateValue) return '';
    let date;
    if (typeof dateValue === 'number') {
        date = new Date(dateValue);
    } else if (typeof dateValue === 'string') {
        date = new Date(dateValue);
    } else if (dateValue?.$date) {
        date = new Date(dateValue.$date);
    } else {
        return '';
    }
    if (isNaN(date.getTime())) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]}-${date.getFullYear()}`;
};

const TimelineContent = ({
    matchingStorylines,
    activeTabIndex,
    setActiveTabIndex,
    articleId,
    articleTitle
}) => {

    const hasMatches = matchingStorylines.length > 0;
    const hasMultiple = matchingStorylines.length > 1;
    const activeStoryline = matchingStorylines[activeTabIndex] || matchingStorylines[0];

    return (
        <div className="timeline-panel-content-news">
        {!hasMatches ? (
            <div className="timeline-no-match-news">
            <span className="timeline-no-match-icon-news">🚩</span>
            <p className="timeline-no-match-text-news">No associated storyline</p>

            {articleTitle && (
                <div className="timeline-article-info-news">
                <span className="label-news">Article:</span>
                <span className="title-news">{articleTitle}</span>
                </div>
            )}
            </div>
        ) : (
            <>
            {hasMultiple && (
            <div className="timeline-tabs-news">
                {matchingStorylines.map((sl, idx) => (
                <button
                    key={sl.storyline_id || idx}
                    className={`timeline-tab-news ${idx === activeTabIndex ? 'active' : ''}`}
                    onClick={() => setActiveTabIndex(idx)}
                >
                    {sl.storyline_title || `Storyline ${idx + 1}`}
                </button>
                ))}
            </div>
            )}

            {activeStoryline && (
            <div className="timeline-storyline-header-news">
                <h3 className="timeline-storyline-title-news">
                {activeStoryline.storyline_title || 'Untitled Storyline'}
                </h3>
            </div>
            )}

            <div className="timeline-events-container-news">
                {activeStoryline?.timelines?.map((event, idx) => {
                const eventId = event.event_id?.$oid || event.event_id;
                // const isCurrentArticle = eventId === articleId;
                const isCurrentArticle = String(eventId) === String(articleId);

                return (
                    <div
                    key={event.event_id || idx}
                    className={`timeline-event-news ${
                        isCurrentArticle ? 'timeline-event-active-news' : ''
                    }`}
                    >
                    <div className="timeline-event-line-news">
                        <div className="timeline-event-dot-news" />

                        {idx < activeStoryline.timelines.length - 1 && (
                        <div className="timeline-event-connector-news" />
                        )}
                    </div>

                    <div className="timeline-event-content-news">
                        <span className="timeline-event-date-news">
                        {formatTimelineDate(event.date || event.published_date)}
                        </span>

                        <a
                        href={event.source_url || event.url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="timeline-event-title-news"
                        >
                        {event.title || 'Untitled Event'}
                        {/* <span className="timeline-info-icon-news">ⓘ</span> */}
                        </a>
                    </div>
                    </div>
                );
                })}
            </div>
            </>
        )}
        </div>
    );
};

const TimelinePanel = ({ isOpen, onClose, articleId, articleTitle, articleUrl, storylines = [], hasActiveFilters = false }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    // Find all storylines that contain this article's ID in their timelines
    const matchingStorylines = useMemo(() => {
        if (!articleId || !storylines?.length) return [];
        return storylines.filter(storyline =>
            storyline?.timelines?.some(t => {
                const eventId = t?.event_id?.$oid || t?.event_id;
                return String(eventId) === String(articleId);
            })
        );
    }, [articleId, storylines]);

    // const hasMatches = matchingStorylines.length > 0;
    // const hasMultiple = matchingStorylines.length > 1;

    // Reset tab index when article changes
    // const activeStoryline = matchingStorylines[activeTabIndex] || matchingStorylines[0];

    // if (!isOpen) return null;

    // return (
    //     <>
    //         <div
    //             className="timeline-overlay-news open-news"
    //             onClick={onClose}
    //         />

    //         <div className={`timeline-panel-news open-news ${hasActiveFilters ? 'has-active-filters' : ''}`}>
    //             <div className="timeline-panel-header-news">
    //                 <h2 className="timeline-panel-title-news">Timeline</h2>
    //                 <button className="timeline-close-button-news" onClick={onClose}>
    //                     <X size={24} />
    //                 </button>
    //             </div>

    //             <div className="timeline-panel-content-news">
    //                 {!hasMatches ? (
    //                     /* No-match state */
    //                     <div className="timeline-no-match-news">
    //                         <span className="timeline-no-match-icon-news">🚩</span>
    //                         <p className="timeline-no-match-text-news">No associated storyline</p>
    //                         {articleTitle && (
    //                             <div className="timeline-article-info-news">
    //                                 <span className="label-news">Article:</span>
    //                                 <span className="title-news">{articleTitle}</span>
    //                             </div>
    //                         )}
    //                     </div>
    //                 ) : (
    //                     <>
    //                         {/* Tab bar for multiple storylines */}
    //                         {hasMultiple && (
    //                             <div className="timeline-tabs-news">
    //                                 {matchingStorylines.map((sl, idx) => (
    //                                     <button
    //                                         key={sl.storyline_id || idx}
    //                                         className={`timeline-tab-news ${idx === activeTabIndex ? 'active' : ''}`}
    //                                         onClick={() => setActiveTabIndex(idx)}
    //                                         title={sl.storyline_title}
    //                                     >
    //                                         {sl.storyline_title || `Storyline ${idx + 1}`}
    //                                     </button>
    //                                 ))}
    //                             </div>
    //                         )}

    //                         {/* Storyline title */}
    //                         {activeStoryline && (
    //                             <div className="timeline-storyline-header-news">
    //                                 <h3 className="timeline-storyline-title-news">
    //                                     {activeStoryline.storyline_title || 'Untitled Storyline'}
    //                                 </h3>
    //                             </div>
    //                         )}

    //                         {/* Timeline events */}
    //                         <div className="timeline-events-container-news">
    //                             {activeStoryline?.timelines?.map((event, idx) => {
    //                                 const eventId = event.event_id?.$oid || event.event_id;
    //                                 const isCurrentArticle = eventId === articleId;
    //                                 return (
    //                                     <div
    //                                         key={event.event_id || idx}
    //                                         className={`timeline-event-news ${isCurrentArticle ? 'timeline-event-active-news' : ''}`}
    //                                     >
    //                                         <div className="timeline-event-line-news">
    //                                             <div className="timeline-event-dot-news" />
    //                                             {idx < activeStoryline.timelines.length - 1 && (
    //                                                 <div className="timeline-event-connector-news" />
    //                                             )}
    //                                         </div>
    //                                         <div className="timeline-event-content-news">
    //                                             <span className="timeline-event-date-news">
    //                                                 {formatTimelineDate(event.date || event.published_date)}
    //                                             </span>
    //                                             <a
    //                                                 href={event.source_url || event.url || event.news_url || '#'}
    //                                                 target="_blank"
    //                                                 rel="noopener noreferrer"
    //                                                 className="timeline-event-title-news"
    //                                                 title={event.title || event.event_title || ''}
    //                                             >
    //                                                 {event.title || event.event_title || 'Untitled Event'}
    //                                                 <span className="timeline-info-icon-news">ⓘ</span>
    //                                             </a>
    //                                             {(event.description || event.summary) && (
    //                                                 <p className="timeline-event-desc-news">
    //                                                     {event.description || event.summary}
    //                                                 </p>
    //                                             )}
    //                                             {event.domain && (
    //                                                 <span className="timeline-event-domain-news">
    //                                                     {event.domain}
    //                                                 </span>
    //                                             )}
    //                                         </div>
    //                                     </div>
    //                                 );
    //                             })}
    //                         </div>
    //                     </>
    //                 )}
    //             </div>
    //         </div>
    //     </>
    // );
    if (!isOpen) return null;

    return (
        <GenericOverviewSideCard
            showMoreModal={isOpen}
            setShowMoreModal={onClose}
            titleForSideCard="Timeline"
            comp={
            <TimelineContent
                matchingStorylines={matchingStorylines}
                activeTabIndex={activeTabIndex}
                setActiveTabIndex={setActiveTabIndex}
                articleId={articleId}
                articleTitle={articleTitle}
            />
            }
            minWidthForDrawer="40%"
            disableXbtn={false}
        />
    );
};

export default TimelinePanel;
